import Phaser from 'phaser';
import './style.css';
import { GameScene } from './scenes/GameScene';
import { HomeScene } from './scenes/HomeScene';

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#dff4ff',
  scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH, width: 430, height: 760 },
  render: { antialias: true, pixelArt: false },
  input: { activePointers: 2 },
  scene: [HomeScene, GameScene],
});
